import {connect} from 'react-redux';
import {withRouter} from "react-router-dom";
import Component from './Component';
import {getUserInfo} from '../Auth/Actions';
import {getAllCities, getCategories, onMainClick} from './Actions';


const mapStateToProps = (state) => (
  {
    auth: state.auth
  }
);

const mapDispatchToProps = (dispatch) => (
  {
    getAllCities: () => {
      dispatch(getAllCities())
    },
    getCategories: () => {
      dispatch(getCategories())
    },
    getUserInfo: () => {
      dispatch(getUserInfo())
    },
    onMainClick: () => {
      dispatch(onMainClick())
    }
  }
);

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Component));


// WEBPACK FOOTER //
// ./src/app/containers/Main/index.js